import {
  importNissanPriceListRequestSchema,
  type ImportNissanPriceListRequest,
} from './ImportNissanPriceListRequestSchema';

export const importNissanPriceListMessageInputSchema = importNissanPriceListRequestSchema;

export type ImportNissanPriceListMessageInput = ImportNissanPriceListRequest;
